export default __webpack_public_path__ + "static/media/marker-expert.93fb08de.svg";